export const generateTitle = (title, left = 'left') => [
    {
        text: title,
        top: 0,
        left,
        textStyle: {
            color: '#244B60',
            fontSize: '12px',
            fontWeight: 700
        }
    }
];
